<!--  -->
<template>
  <div class="emer_box">
    <div class="aerw">
      <div class="sewawa">
        <div class="chooseqi">选择企业：</div>
        <el-select
          v-model="query.corp_id"
          placeholder="请选择企业"
        >
          <el-option
            v-for="item in selectoptionsall"
            :key="item.corp_id"
            :label="item.corp_name"
            :value="item.corp_id"
          />
        </el-select>
      </div>
      <div
        class="sewawa"
      >
        <div class="chooseqi">是否养号：</div>
        <el-select
          v-model="query.reception_state"
          placeholder="是否养号"
        >
          <el-option
            v-for="item in selectoptionstwo"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div
        class="sewawa"
      >
        <div class="chooseqi">是否转盘客服：</div>
        <el-select
          v-model="query.book_kf"
          placeholder="是否转盘客服"
        >
          <el-option
            v-for="item in selectoptionsthree"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click.stop="search"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh-right"
        @click.stop="dawe"
      >重置</el-button>
      <el-button
        type="success"
        icon="el-icon-plus"
        @click.stop="addallconmoy"
      >新增客服</el-button>
      <el-button
        type="primary"
        icon="el-icon-office-building"
        @click="serviceprovider"
      >服务商</el-button>
      <el-button
        type="warning"
        icon="el-icon-edit-outline"
        @click="qiweiclick"
      >企微公司</el-button>
      <el-button
        type="success"
        icon="el-icon-chat-dot-round"
        @click="wechatclirclr"
      >小程序管理</el-button>
      <!-- <el-button type="primary" style="margin-bottom:20px" @click="zhanghuclick">企微账户</el-button> -->
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="corp_name"
        label="企业名称"
      />
      <el-table-column
        prop="welcome_words"
        label="欢迎语"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="欢迎语"
            trigger="hover"
            :content="scope.row.welcome_words"
          >
            <p
              slot="reference"
              class="titip"
            >{{ scope.row.welcome_words }}</p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="kf_name"
        label="客服名称"
      />
      <el-table-column
        align="center"
        prop="official_account"
        label="公众号"
      />

      <el-table-column
        prop="welcomeWords"
        label="客服人员"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <el-button
            v-for="item,indexr in scope.row.kf_reception_user"
            :key="indexr"
            type="text"
          >{{ item }}</el-button>
        </template>
      </el-table-column>

      <el-table-column
        prop="welcomeWords"
        label="客服头像"
        align="center"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.avatar_url"
            class="chooseimgr"
            alt=""
          >
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="slaveClickNum"
        label="今日客服访问次数"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.slave_click_num }}</span>
          <div><el-button
            type="text"
            @click="lookkan(scope.row.kf_open_id,'click')"
          >查看</el-button></div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="kfWelcomeSendCount"
        label="今日欢迎语发送次数"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.kf_welcome_send_count }}</span>
          <div><el-button
            type="text"
            @click="lookkan(scope.row.kf_open_id,'welcome_send')"
          >查看</el-button></div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="kfKeywordSendCount"
        label="今日关键词发送次数"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.kf_keyword_send_count }}</span>
          <div><el-button
            type="text"
            @click="lookkan(scope.row.kf_open_id,'keyword_send')"
          >查看</el-button></div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="slave_uv"
        label="今日客服访问人数"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.slave_uv }}</span>
          <div><el-button
            type="text"
            @click="lookkan(scope.row.kf_open_id,'uv')"
          >查看</el-button></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="welcomeWords"
        label="是否养号"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.reception_state == 3">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="book_kf_text"
        label="是否转盘客服"
        align="center"
      />
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
        width="350"
      >
        <template slot-scope="scope">
          <div class="btn-wrap-box">
            <el-button
              v-if="userIfon.isRoot == 1"
              type="primary"
              size="mini"
              @click="editwe(scope.row)"
            >编辑</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleter(scope.row.id)"
            >删除</el-button>
            <el-button
              type="success"
              size="mini"
              @click="(draweritem = true),(drawerItem = scope.row)"
            >绑定飞书</el-button>
            <el-button
              type="warning"
              size="mini"
              @click="addmessage(scope.row.kf_open_id,scope.row.corp_id)"
            >客服消息</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="copycustomer(scope.row.id)"
            >复制客服</el-button>
            <!-- v-clipboard:copy="scope.row.kfLink"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError" -->
            <el-button
              type="success"
              size="mini"
              @click="cowe(scope.row,$event)"
            >复制链接</el-button>
          </div>

        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <!-- :visible.sync="dialogVisible" -->
    <el-dialog
      v-loading="loading"
      :visible.sync="dialogVisible"
      :title="qiyedisabled == true ? '编辑客服': '新增客服'"
      :close-on-click-modal="false"
      class="popup-mid"
      @close="closempty"
    >
      <!-- :before-close="handleClose" -->
      <div>
        <div
          class="sewawa"
          style="margin-bottom:20px"
        >
          <div class="chooseqi">是否养号：</div>
          <el-radio-group
            v-model="serialnumberradio"
            @change="yangnumber"
          >
            <el-radio-button :label="3">是</el-radio-button>
            <el-radio-button :label="1">否</el-radio-button>
          </el-radio-group>
        </div>
        <div class="sedab">
          <div class="sewawa">
            <div class="chooseqi">选择企业：</div>
            <!-- :disabled="qiyedisabled" -->
            <el-select
              v-model="corpKeyId"
              placeholder="请选择企业"
              :disabled="serialnumberradio==1 || qiyedisabled"
              @change="chhoser"
            >
              <el-option
                v-for="item in selectoptions"
                :key="item.corp_id"
                :label="item.corp_name"
                :value="item.corp_id"
              />
            </el-select>
          </div>
          <div
            class="sewawa"
            style="margin-left:20px"
          >
            <div class="chooseqi">选择员工：</div>
            <el-select
              v-model="yuanids"
              :disabled="serialnumberradio==1 && !qiyedisabled"
              placeholder="无"
              multiple
            >
              <el-option
                v-for="items in selectoptionsyuan"
                :key="items.id"
                :label="items.name"
                :value="items.id"
              />
            </el-select>
            <el-button
              v-if="!qiyedisabled && yuanids.length!=0"
              style="margin-left:10px"
              type="primary"
              size="mini"
              @click="huanyipi"
            >换一批</el-button>
          </div>
        </div>

        <div class="sedab">
          <div
            class="sewawa"
            style="margin-top:20px"
          >
            <div class="chooseqi">客服名称：</div>
            <div>
              <el-input
                v-model="kfName"
                style="width:200px"
                placeholder="请输入客服名称"
              />
            </div>
          </div>
        </div>
        <div
          class="sewawa"
          style="margin-top:20px"
        >
          <div class="welcometext">公众号：</div>
          <div>
            <el-input
              v-model="officialAccount"
              style="width:200px"
              placeholder="无"
              @input="aowrwr"
            />
          </div>
        </div>

        <div
          class="sewawa"
          style="margin-top:20px"
        >
          <div>
            <div class="wedarfs">欢迎语：</div>
            <el-button
              type="primary"
              size="mini"
              style="margin-left:10px;margin-top:10px"
              @click="huan"
            >切换</el-button>
          </div>

          <div>
            <el-input
              v-model="welcomeWords"
              type="textarea"
              placeholder="请输入欢迎语"
            />
          </div>

        </div>
        <div
          class="sewawa"
          style="margin-top:20px"
        >
          <div class="chooseqi">选择头像：</div>
          <div>
            <img
              class="chooseimg"
              :src="avatarurl + avatarlist[avatarindex]"
            >
          </div>
          <el-button
            type="text"
            style="margin-left:10px"
            @click="avaterclick"
          >换一张</el-button>
          <!-- <el-upload
            class="upload-demo"
            drag
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="changeUpload"
          >
            <div class="choosecover">
              <div class="choose_cover">选择头像</div>
            </div>
          </el-upload> -->
          <el-upload
            ref="upload"
            class="upload-demo"
            action="#"
            :http-request="httpRequest"
            :multiple="true"
            :show-file-list="false"
            :limit="100"
          >
            <el-button
              size="small"
              type="text"
              plain
            >选择头像</el-button>
          </el-upload>
        </div>
        <!-- 编辑 -->
        <div>
          <div v-if="qiyedisabled == true">
            <div>
              <el-button
                size="mini"
                type="primary"
                @click="newlyadded"
              >新增</el-button>
            </div>
            <div v-if="slaveKf.length!=0">
              <div class="idpada_box">
                <div
                  v-for="(itemr,indexr) in slaveKf"
                  :key="indexr"
                  class="sedabone"
                >
                  <!-- {{ indexr+1 }} -->
                  <div><img
                    class="chooseimgwe"
                    :src="itemr.avatar"
                    alt=""
                  ></div>
                  <div class="sadewname">访问次数：{{ itemr.count }}</div>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="dearwe(itemr.id,indexr)"
                  >删除</el-button>
                  <!-- <el-button size="mini" type="primary">复制链接</el-button> -->
                  <el-button
                    v-clipboard:copy="itemr.kf_link"
                    v-clipboard:success="onCopys"
                    v-clipboard:error="onErrors"
                    type="primary"
                    size="mini"
                  >复制链接</el-button>
                </div>
              </div>
            </div>

          </div>
          <div v-else>
            <div class="daswrwq">
              <div>
                创建多个：
              </div>
              <div>
                <el-radio-group
                  v-model="radio"
                  @change="creatclick"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div
              v-if="radio === 1"
              class="daswrwq"
            >
              <div>
                新增数量：
              </div>
              <div>
                <el-input
                  v-model="addnum"
                  placeholder="请输入内容"
                />
              </div>
            </div>
          </div>

        </div>

        <!-- <img :src="testsrc" style="width:50px;height:50px;object-fit: contain;" alt=""> -->
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="determineclick"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false"
      @close="resrist"
    >
      <viewbigpictures ref="viewbig" />
    </el-drawer>

    <el-drawer
      title="服务商"
      :visible.sync="serviceproviderview"
      :with-header="false"
      @close="resrist"
    >
      <serviceprovider ref="serviceproviderviewr" />
    </el-drawer>

    <el-drawer
      title="我是标题"
      :visible.sync="drawerr"
      :with-header="false"
    >
      <wechatzhanghu />
    </el-drawer>

    <el-drawer
      title="小程序管理"
      :visible.sync="wechatdrawerr"
      :with-header="false"
    >
      <wechatset ref="wechatsetview" />
    </el-drawer>
    <el-dialog
      title="编辑"
      :visible.sync="editdialogVisible"
    >
      <editdialog
        ref="edirwe"
        @updata="updata"
      />
    </el-dialog>
    <el-dialog
      title="发送记录"
      :visible.sync="paydialogVisible"
    >
      <payrecorddialog ref="paydialog" />
    </el-dialog>
    <!-- vueCropper 剪裁图片实现 弹窗-->
    <el-dialog
      title="图片剪裁"
      :visible.sync="caidialogVisible"
      append-to-body
    >
      <div class="cropper-content">
        <div
          class="cropper"
          style="text-align:center"
        >
          <vueCropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :fixed="option.fixed"
            :center-box="option.centerBox"
            :info-true="option.infoTrue"
            :fixed-box="option.fixedBox"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :fixed-number="option.fixedNumber"
            :enlarge="option.enlarge"
            :mode="option.mode"
          />
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          :loading="loading"
          @click="finish"
        >确认</el-button>
        <el-button @click="quxiao">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 新增修改消息 -->
    <el-dialog
      title="消息"
      :visible.sync="messagedialogVisible"
      :destroy-on-close="true"
      class="popup-mid"
    >
      <el-radio-group
        v-model="bigradio"
        style="margin-bottom:20px"
        @change="bigtype"
      >
        <el-radio-button :label="1">关键词</el-radio-button>
        <el-radio-button :label="2">延时推送</el-radio-button>
      </el-radio-group>
      <addmessage
        v-if="bigradio === 1"
        ref="messagedialog"
        @updatawr="updatawr"
      />
      <addmessageone
        v-if="bigradio === 2"
        ref="messagedialogr"
        @updatawr="updatawr"
      />
    </el-dialog>
    <!-- 新增查看echarts -->
    <el-dialog
      title="详情"
      :visible.sync="lookecharts"
      :destroy-on-close="true"
      class="popup-mid"
    >
      <lookecahrts ref="lookecahrt" />
    </el-dialog>
    <!-- 绑定飞书 @close="$refs.draweritem.closeDrawer()"    -->
    <!-- <el-drawer
      ref="draweritem"
      title="详情"
      :visible.sync="draweritem"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <Details v-if="draweritem" :drawer-item="drawerItem" />
    </el-drawer> -->
    <el-dialog
      title="绑定飞书"
      :visible.sync="draweritem"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="$refs.details.closes()"
    >
      <Details
        v-if="draweritem"
        ref="details"
        :drawer-item="drawerItem"
        :getlist="getlistData"
      />
    </el-dialog>

  </div>
</template>

<script>
import Details from './components/DetailsList.vue'
import viewbigpictures from './components/viewbigpictures.vue'
import serviceprovider from './components/serviceprovider.vue'
import wechatzhanghu from './components/wechatzhanghu.vue'
import editdialog from './components/editdialog.vue'
import addmessage from './components/addmessage.vue'
import addmessageone from './components/addmessageone.vue'
import lookecahrts from './components/lookecahrts.vue'
// customerservicecreat 新增确定 以后备用$(旧)
import {
  wechatcomupwechatgroup,
  enterpriseMicro,
  getavatarList,
  getstaffList,
  /* customerservicecreat */ customerservicelist,
  customerservicedelte,
  updayaservicedelte,
  updateDepartment,
  updayaservicedelter,
  beforehandstore,
  changebatch,
  customerservicecreatv2,
  copyAuthlink,
  copyStoreV3
} from '@/api/providerAccountManagement/servicePorviderList2.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import payrecorddialog from './components/payrecorddialog.vue'
import wechatset from './components/wechatset.vue'
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken.js'
import { getInfo } from '@/api/user'
import getNowDate from '@/utils/mixins/convertToHump.js'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'
import { getQcConfig } from '@/api/sourceminiprogram.js'
export default {
  components: {
    Details,
    viewbigpictures,
    wechatzhanghu,
    editdialog,
    PaginationRight,
    payrecorddialog,
    addmessage,
    addmessageone,
    lookecahrts,
    serviceprovider,
    wechatset
  },
  mixins: [getNowDate],
  data() {
    return {
      draweritem: false,
      serviceproviderview: false,
      serialnumberradio: 1,
      bigradio: 1,
      chuanid: null,
      corpid: null,
      radio: 2,
      addnum: 0,
      total: null,
      tableData: [],
      options: [],
      optionsr: [],
      account_id: null, // 企微账户
      company_id: null, // 企微公司
      index: 0,
      ster: null,
      dialogVisible: false,
      editdialogVisible: false,
      paydialogVisible: false,
      testsrc: '',
      caidialogVisible: false,
      messagedialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        // outputType: 'jpeg', // 裁剪生成图片的格式     :output-type="option.outputType"
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 640, // 默认生成截图框宽度
        autoCropHeight: 640, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: 'contain' // 图片默认渲染方式  contain , cover, 100px, 100% auto
      },
      arr: [
        {
          time: new Date(2022, 9, 10, 18, 40),
          control: true,
          groupname: '',
          message: '',
          controlchuan: 1,
          timechuan: '18:40'
        }
      ],
      drawer: false,
      drawerr: false,
      loading: false,
      query: {
        corp_id: null,
        reception_state: null,
        book_kf: null,
        page: 1,
        pageSize: 10
      },
      mathRandom: null,
      selectoptionsall: [],
      selectoptions: [],
      selectoptionstwo: [
        {
          value: 1,
          label: '否'
        },
        {
          value: 3,
          label: '是'
        }
      ],
      selectoptionsthree: [
        {
          value: 1,
          label: '否'
        },
        {
          value: 2,
          label: '是'
        }
      ],
      corpKeyId: null,
      avatarurl: '',
      avatarlist: [],
      avatarindex: 0,
      selectoptionsyuan: [],
      yuanids: [],
      kfName: '',
      welcomeWords: '',
      qiyedisabled: false,
      officialAccount: '',
      token: null, // 七牛云token
      ids: null,

      pictype: false,
      slaveKf: [],
      lookecharts: false,
      updataid: null,

      dialogtype: null,
      diantype: 1,
      // dianum1: '点击下方蓝字，关注公众号即可继续阅读~\n\n╔─👇─👇─👇─╗\n\n✅#公众号:\n\n╚─👆─👆─👆─╝',
      dianum1: '╔─👇─👇─👇─╗\n\n✅#公众号:\n\n✅#公众号:\n\n✅#公众号:\n\n╚─👆─👆─👆─╝',
      dianum2: '点击下方蓝字，关注公众号即可继续阅读~\n\n╔─👇─👇─👇─╗\n\n📱📱<a href="此处填写名片链接">点击这里>>继续阅读精彩内容</a>\n\n╚─👆─👆─👆─╝',
      weicawe: '',

      qingqiusuccess: null,

      userIfon: {}, // 账户个人信息
      wechatdrawerr: false,
      config: {}
    }
  },
  created() {
    getInfo().then(data => {
      this.userIfon = data.data
    })
    this.getlist()
    // this.getQiniuToken()
    this.getconfig()
    this.getenterpriselist()
    console.log('1111')
    // this.adddata()
    // this.adddatatwo()
  },
  mounted() {},
  methods: {
    getlistData() {
      this.getlist()
      this.draweritem = false
    },
    handleClose(done) {
      if (this.qingqiusuccess !== 1) {
        if (this.corpKeyId === null) {
          this.$message.error('正在生成客服')
          return
        }
        // eslint-disable-next-line eqeqeq
        if (this.yuanids.length == 0) {
          this.$message.error('正在生成客服')
          return
        }
      }

      this.dialogVisible = false
    },
    closempty() {
      console.log(this.dialogtype)
      // this.resutt()
      // eslint-disable-next-line eqeqeq
      // if (this.dialogtype == null) {
      //   console.log('666')
      //   customerservicedelte({
      //     id: this.updataid,
      //     hard: 1
      //   }).then(res => {
      //   // this.$message({
      //   //   type: 'success',
      //   //   message: '删除成功!'
      //   // })
      //     this.getlist()
      //   })
      // }
    },
    search() {
      this.getlist()
    },
    dawe() {
      this.query.corp_id = null
      this.query.reception_state = null
      this.query.book_kf = null
      this.query.page = 1
      this.query.pageSize = 10
      this.getlist()
    },
    // 获取列表
    async getlist() {
      this.loading = true
      const data = await customerservicelist(this.query)
      this.tableData = data.data.list
      this.loading = false
      this.total = data.data.total
      console.log('data', data)
    },
    // 获取企业筛选列表
    async getenterpriselist() {
      const data = await enterpriseMicro()
      this.selectoptionsall = data.data
      console.log('企业筛选列表', data)
    },
    // 获取企业筛选列表
    async getenterpriselistr() {
      const data = await enterpriseMicro({
        kf_status: 1
      })
      this.selectoptions = data.data
      console.log('企业筛选列表1', data)
    },

    // 获取头像
    async getavatarLists() {
      const data = await getavatarList()
      this.avatarurl = data.data.domain
      this.avatarlist = data.data.list
      console.log('data', data, this.qiyedisabled)
      if (this.qiyedisabled === false) {
        this.avatarindex = this.RandomNumBoth(0, data.data.list.length - 1)
      }
    },
    // 更新站点
    async updateDepartment(id) {
      await updateDepartment({ corp_id: id })
    },
    async chhoser(val) {
      console.log('val', val)
      // 更新部门成员
      // await this.updateDepartment(val)
      this.yuanids = []
      this.selectoptionsyuan = []
      const data = await getstaffList({
        corp_id: val
      })
      if (data.data === null) {
        this.selectoptionsyuan = []
        return
      }
      this.selectoptionsyuan = data.data
      console.log(this.selectoptionsyuan.length)

      if (this.selectoptionsyuan.length === 3) {
        const data = this.selectoptionsyuan.map(item => {
          return item.id
        })
        console.log('data1', data)
        this.yuanids = data
      }
      if (this.selectoptionsyuan.length === 4) {
        const data = this.selectoptionsyuan.map(item => {
          return item.id
        })
        data.sort(function() {
          return Math.random() - 0.5
        })

        const num = this.RandomNumBoth(3, 4)
        console.log('随机数', num)
        if (num === 4) {
          console.log('111')
          this.yuanids = data
        }
        if (num === 3) {
          console.log('222')
          this.yuanids = data.slice(0, 3)
        }
        console.log('data2', data)
      }
      if (this.selectoptionsyuan.length === 5) {
        const data = this.selectoptionsyuan.map(item => {
          return item.id
        })
        data.sort(function() {
          return Math.random() - 0.5
        })

        const num = this.RandomNumBoth(3, 6)
        console.log('随机数', num)
        if (num === 4) {
          console.log('111')
          this.yuanids = data.slice(0, 4)
        }
        if (num === 3) {
          console.log('222')
          this.yuanids = data.slice(0, 3)
        }
        if (num === 5) {
          console.log('222')
          this.yuanids = data
        }
        if (num > 5) {
          console.log('222')
          this.yuanids = data
        }
        console.log('data2', data)
      }
      if (this.selectoptionsyuan.length > 5) {
        const data = this.selectoptionsyuan.map(item => {
          return item.id
        })
        data.sort(function() {
          return Math.random() - 0.5
        })

        const num = this.RandomNumBoth(3, 6)
        console.log('随机数>>', num)
        if (num === 4) {
          console.log('111')
          this.yuanids = data.slice(0, 4)
        }
        if (num === 3) {
          console.log('222')
          this.yuanids = data.slice(0, 3)
        }
        if (num === 5) {
          console.log('222')
          this.yuanids = data.slice(0, 5)
        }
        if (num > 5) {
          console.log('大于5')
          this.yuanids = data.slice(0, 5)
        }
        console.log('data2', data)
      }
    },
    RandomNumBoth(Min, Max) {
      const Range = Max - Min
      const Rand = Math.random()
      const num = Min + Math.round(Rand * Range) // 四舍五入
      return num
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getlist()
    },
    timechagew(index, val) {
      console.log('timechagew', index, val)
      this.arr[index].timechuan = val
    },
    addbtn() {
      this.arr.push({
        time: new Date(2022, 9, 10, 18, 40),
        control: true,
        groupname: '',
        message: '',
        controlchuan: 1,
        timechuan: '18:40'
      })
      this.$nextTick(() => {
        const el = document.querySelector('.link_box')
        el.scrollTop = el.scrollHeight - el.clientHeight
      })
    },
    reducebtn(index) {
      this.arr.splice(index, 1)
    },
    qiweiclick() {
      this.drawer = true
    },
    zhanghuclick() {
      this.drawerr = true
    },
    resutt() {
      this.account_id = null
      this.company_id = null
      this.arr = []
      this.arr = [
        {
          time: new Date(2022, 9, 10, 18, 40),
          control: true,
          groupname: '',
          message: '',
          controlchuan: 1,
          timechuan: '18:40'
        }
      ]
    },
    resrist() {
      console.log('清空')
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.viewbig.resback()
      }, 100)
    },
    konghzhiselect(index, val) {
      console.log(index, val)
      this.arr[index].control = val
      if (val === true) {
        this.arr[index].controlchuan = 1
      } else {
        this.arr[index].controlchuan = 2
      }
    },
    addallconmoy() {
      this.pictype = false
      this.qiyedisabled = false
      this.dialogVisible = true
      this.getenterpriselistr()
      this.getavatarLists()
      this.restr()
      // this.welcomeWords = `点击下方蓝字，关注公众号即可继续阅读~\n\n╔─👇─👇─👇─╗\n\n✅#公众号:\n\n╚─👆─👆─👆─╝`
      // this.weicawe = `点击下方蓝字，关注公众号即可继续阅读~\n\n╔─👇─👇─👇─╗\n\n✅#公众号:\n\n╚─👆─👆─👆─╝`
      // this.welcomeWords = `╔─👇─👇─👇─╗\n\n✅#公众号:\n\n✅#公众号:\n\n✅#公众号:\n\n╚─👆─👆─👆─╝`
      // this.weicawe = `╔─👇─👇─👇─╗\n\n✅#公众号:\n\n✅#公众号:\n\n✅#公众号:\n\n╚─👆─👆─👆─╝╝`
      this.welcomeWords = `╔─👇─👇─👇─╗\n\n✅#公众号:\n\n╚─👆─👆─👆─╝`
      this.weicawe = `╔─👇─👇─👇─╗\n\n✅#公众号:\n\n╚─👆─👆─👆─╝`
      this.kfName = '回复数字1继续阅读'
      // const str = '点击下方蓝字，关注公众号即可继续阅读~'
      // this.welcomeWords = str.replace(/\n/g, '<br/>')
      // const strw = '6666'
      // this.welcomeWords += strw
      this.dialogtype = null
      // this.getkefulist() // 新版调用函数
      // this.getkefulistrr()// 新版调用函数
    },
    // 获取新增客服信息
    async getkefulist() {
      const data = await beforehandstore({
        welcomeWords: this.welcomeWords
      })

      this.corpKeyId = Number(data.data.list[0].corpKeyId)
      this.yuanids = []
      this.selectoptionsyuan = []
      const datas = await getstaffList({
        corpKeyId: data.data.list[0].corpKeyId
      })
      if (datas.data === null) {
        this.selectoptionsyuan = []
        return
      }
      this.selectoptionsyuan = datas.data
      this.yuanids = data.data.list[0].kfReception
      this.updataid = data.data.list[0].id
    },
    // 获取新增客服信息
    getkefulistrr() {
      beforehandstore({
        welcomeWords: this.welcomeWords
      })
        .then(data => {
          this.corpKeyId = Number(data.data.list[0].corpKeyId)
          this.yuanids = []
          this.selectoptionsyuan = []
          getstaffList({
            corpKeyId: data.data.list[0].corpKeyId
          }).then(datas => {
            if (datas.data === null) {
              this.selectoptionsyuan = []
              return
            }
            this.selectoptionsyuan = datas.data
            this.yuanids = data.data.list[0].kfReception
            this.updataid = data.data.list[0].id
          })
        })
        .catch(error => {
          console.log('error', error)
          this.qingqiusuccess = 1
        })
    },
    // 换一批
    async huanyipi() {
      const data = await changebatch({
        corp_id: this.corpKeyId
      })
      console.log('换一批', data.data)
      this.yuanids = data.data
    },
    async naclick(item) {
      console.log('item', item)
      let strs = null
      if (item.include_status === 1) {
        strs = 2
      } else {
        strs = 1
      }
      const id = item.id
      const account_id = item.account_id
      const company_id = item.company_id
      const group_name = item.group_name
      const message = item.message
      const timeHi = item.timeHi

      const data = await wechatcomupwechatgroup(id, account_id, company_id, group_name, message, timeHi, strs)
      console.log('data', data)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.getlist()
      this.mathRandom = Math.random()
    },
    async editwe(item) {
      this.qiyedisabled = true
      this.dialogtype = 1
      await this.updateDepartment(item.corp_id)
      this.getenterpriselistr()
      this.getavatarLists()
      console.log(item)

      const data = await getstaffList({
        corp_id: item.corp_id
      })
      if (data.data === null) {
        this.selectoptionsyuan = []
      } else {
        this.selectoptionsyuan = data.data
      }

      this.corpKeyId = item.corp_id
      if (item.kf_reception) {
        this.yuanids = item.kf_reception
      }
      const index = this.avatarlist.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return items == item.avatar
      })
      console.log('index', index)
      // eslint-disable-next-line eqeqeq
      if (index == -1) {
        this.avatarlist.push(item.avatar)
        this.avatarindex = this.avatarlist.length - 1
        this.pictype = true
        console.log('没找到')
      } else {
        console.log('找到了')
        this.pictype = false
        this.avatarindex = index
      }
      console.log('item.kfName')
      this.kfName = item.kf_name
      this.serialnumberradio = item.reception_state
      this.welcomeWords = item.welcome_words
      this.officialAccount = item.official_account

      this.ids = item.id
      if (item.slave_kf) {
        this.slaveKf = item.slave_kf
      } else {
        this.slaveKf = []
      }

      this.dialogVisible = true
    },
    updata() {
      this.editdialogVisible = false
      this.getlist()
    },
    deleter(id) {
      const that = this
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(res => {
          customerservicedelte({
            id: id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.getlist()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },

    dearwe(id, index) {
      const that = this
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(res => {
          customerservicedelte({
            id: id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.slaveKf.splice(index, 1)
            that.getlist()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    // 发送记录
    send(id) {
      this.paydialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.paydialog.customeoncallback(id)
      }, 100)
    },
    avaterclick() {
      console.log(this.avatarlist.length, this.avatarlist)
      if (this.avatarlist.length <= this.avatarindex + 1) {
        // eslint-disable-next-line eqeqeq
        // if (this.avatarlist[this.avatarlist.length - 1] == this.testsrc) {
        //   this.avatarlist.splice(this.avatarlist.length - 1, 1)
        //   console.log('666', this.avatarlist)
        // }
        // eslint-disable-next-line eqeqeq
        if (this.pictype == true) {
          this.avatarlist.splice(this.avatarlist.length - 1, 1)
          console.log('666', this.avatarlist)
        }
        this.avatarindex = 0
        this.pictype = false
        return
      }
      this.avatarindex++
    },
    async determineclick() {
      console.log(this.addnum, 'this.addnum')

      console.log('this.avatarlist[this.avatarindex]', this.avatarlist[this.avatarindex])
      // eslint-disable-next-line eqeqeq
      if (this.serialnumberradio == 3) {
        if (this.corpKeyId === null) {
          this.$message.error('请选择企业')
          return
        }
        if (this.yuanids.length === 0) {
          this.$message.error('请选择员工')
          return
        }
      }

      if (this.kfName === '') {
        this.$message.error('请输入客服名称')
        return
      }
      if (this.welcomeWords === '') {
        this.$message.error('请输入欢迎语')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.radio == 1 && this.addnum == '' && this.qiyedisabled == false) {
        this.$message.error('请输入新增数量')
        return
      }
      // if (this.officialAccount === '') {
      //   this.$message.error('请输入公众号')
      //   return
      // }
      this.loading = true
      if (this.qiyedisabled === true) {
        console.log('编辑')
        const data = await updayaservicedelte({
          id: this.ids,
          avatar: this.avatarlist[this.avatarindex],
          kf_name: this.kfName,
          kf_reception: this.yuanids,
          welcome_words: this.welcomeWords,
          official_account: this.officialAccount,
          reception_state: this.serialnumberradio
        })
        this.dialogtype = 1
        console.log('更新', data)
        this.$message({
          message: '更新成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.loading = false
        this.getlist()
        this.restr()
      } else {
        console.log('新增')
        customerservicecreatv2({
          corp_id: this.corpKeyId,
          avatar: this.avatarlist[this.avatarindex],
          kf_name: this.kfName,
          kf_reception: this.yuanids,
          welcome_words: this.welcomeWords,
          official_account: this.officialAccount,
          create_num: this.addnum,
          reception_state: this.serialnumberradio
        })
          .then(res => {
            console.log('res', res)
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.loading = false
            this.getlist()
            this.restr()
          })
          .catch(error => {
            this.loading = false
            console.log('error', error)
          })
        // updayaservicedelte({
        //   id: this.updataid,
        //   avatar: this.avatarlist[this.avatarindex],
        //   kfName: this.kfName,
        //   kfReception: this.yuanids,
        //   welcomeWords: this.welcomeWords,
        //   officialAccount: this.officialAccount,
        //   receptionState: this.serialnumberradio
        // }).then(res => {
        //   this.dialogtype = 1
        //   console.log('res', res)
        //   this.$message({
        //     message: '更新成功',
        //     type: 'success'
        //   })
        //   this.dialogVisible = false
        //   this.loading = false
        //   this.getlist()
        //   this.restr()
        // }).catch(error => {
        //   this.loading = false
        //   this.dialogtype = null
        //   console.log('error', error)
        // })
      }
      // const data = await customerservicecreat({
      //   corpKeyId: this.corpKeyId,
      //   avatar: this.avatarlist[this.avatarindex],
      //   kfName: this.kfName,
      //   kfReception: this.yuanids,
      //   welcomeWords: this.welcomeWords,
      //   officialAccount: this.officialAccount
      // })

      // this.$message({
      //   message: '添加成功',
      //   type: 'success'
      // })
      // this.dialogVisible = false
      // this.loading = false
      // this.getlist()
      // this.restr()
      // console.log('data', data)
    },
    restr() {
      this.corpKeyId = null
      this.avatarindex = 0
      this.kfName = ''
      this.yuanids = []
      this.welcomeWords = ''
      this.officialAccount = ''
      this.pictype = false
      this.radio = 2
      this.addnum = 0
      this.serialnumberradio = 1
    },
    onCopy(value, event) {
      console.log(value, event)
      // eslint-disable-next-line eqeqeq
      // if (id == 3) {
      //   this.$confirm('该客服链接为养号客服，是否确定复制?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$message({
      //       message: '复制成功',
      //       type: 'success'
      //     })
      //   }).catch(() => {
      //     // this.$message({
      //     //   type: 'info',
      //     //   message: '已取消删除'
      //     // })
      //   })
      // } else {
      //   this.$message({
      //     message: '复制成功',
      //     type: 'success'
      //   })
      // }
    },
    cowe(item, $event) {
      // eslint-disable-next-line eqeqeq
      // if (item.receptionState == 3) {
      //   this.$confirm('该客服链接为养号客服，是否确定复制?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     console.log('item', item.kfLink, $event)
      //     clipboard(item.kfLink, $event)
      //     // this.$message({
      //     //   message: '复制成功',
      //     //   type: 'success'
      //     // })
      //   })
      // } else {
      //   clipboard(item.kfLink, $event)
      // }
      // console.log('item', item.kfLink, $event)
      // clipboard(item.kfLink, $event)
      const _this = this
      // this.$copyText(item.kfLink).then(function(e) {
      //   // eslint-disable-next-line eqeqeq
      //   if (item.receptionState == 3) {
      //     _this.$confirm('该客服链接为养号客服，是否确定复制?', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       type: 'warning'
      //     }).then(() => {
      //       _this.$message({
      //         message: '复制成功',
      //         type: 'success'
      //       })
      //     })
      //   } else {
      //     _this.$message({
      //       message: '复制成功',
      //       type: 'success'
      //     })
      //   }
      // }, function(err) {
      //   console.log(err)
      //   // this.$Message.error(err)
      //   _this.$message.error('复制失败')
      // })
      this.$copyText(item.kf_link).then(
        function(e) {
          // eslint-disable-next-line eqeqeq
          if (item.reception_state == 3) {
            // _this.$message({
            //   message: '复制成功,该客服',
            //   type: 'success'
            // })
            _this.$alert('复制成功，该链接为养号专属，仅限内部使用', '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {
                // this.$message({
                //   type: 'info',
                //   message: `action: ${action}`
                // })
              }
            })
          } else {
            _this.$message({
              message: '复制成功',
              type: 'success'
            })
          }
        },
        function(err) {
          console.log(err)
          // this.$Message.error(err)
          _this.$message.error('复制失败')
        }
      )
    },
    copyauthlink() {
      const _this = this
      copyAuthlink().then(res => {
        console.log('res', res)
        this.$copyText('111').then(
          function(e) {
            _this.$message({
              message: '复制成功',
              type: 'success'
            })
          },
          function(err) {
            console.log(err)
            _this.$message.error('复制失败')
          }
        )
      })
    },
    onError() {
      this.$message.error('复制失败')
    },
    onCopys() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onErrors() {
      this.$message.error('复制失败')
    },
    // 获取七牛token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    // 上传按钮   限制图片大小 裁剪的上传
    changeUpload(file, fileList) {
      // const isLt5M = file.size / 1024 / 1024 < 5
      // if (!isLt5M) {
      //   this.$message.error('上传文件大小不能超过 5MB!')
      //   return false
      // }
      const img = new Image()
      console.log('img.height', img.height, 'img.width', img.width)
      const url = URL.createObjectURL(file.raw)
      console.log('url', url)
      this.fileinfo = file
      console.log('file', file)
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = url
        // this.testsrc = url
        this.caidialogVisible = true
      })
    },
    // 截图成功上传图片
    finish() {
      this.$refs.cropper.getCropBlob(data => {
        console.log('data', data, this.fileinfo)
        // var sizebig = data.size
        const ftype = this.fileinfo.name.substr(this.fileinfo.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        // const observable = qiniu.upload(data, `workwechat_avatar/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
        //   fname: this.fileinfo.name // 文件名
        // }, {
        //   useCdnDomain: true // cdn域名加速
        // })
        // observable.subscribe({
        //   next() { },
        //   error(err) {
        //     console.log(err)
        //   },
        //   complete: (data) => {
        //     console.log('上传图片data', data)
        //     // eslint-disable-next-line eqeqeq
        //     if (this.pictype == true) {
        //       this.avatarlist.splice(this.avatarlist.length - 1, 1)
        //     }
        //     this.avatarlist.push(data.key)
        //     this.avatarindex = this.avatarlist.length - 1
        //     this.testsrc = data.key
        //     this.pictype = true
        //     console.log(' this.avatarlist', this.avatarlist)
        //     this.caidialogVisible = false
        //   }
        // })

        uploadFilesimg(
          this.fileinfo,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options.Key)
            // this.updataimg = this.config.domain + res.files[0].options.Key
            // this.cover = res.files[0].options.Key
            //     console.log('上传图片data', data)
            // eslint-disable-next-line eqeqeq
            if (this.pictype == true) {
              this.avatarlist.splice(this.avatarlist.length - 1, 1)
            }
            this.avatarlist.push(res.files[0].options.Key)
            this.avatarindex = this.avatarlist.length - 1
            this.testsrc = res.files[0].options.Key
            this.pictype = true
            console.log(' this.avatarlist', this.avatarlist)
            this.caidialogVisible = false
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      })
    },
    quxiao() {
      // this.testsrc = ''
      this.caidialogVisible = false
      console.log(qiniu)
    },

    addmessage(id, corpid) {
      this.messagedialogVisible = true
      this.chuanid = id
      this.corpid = corpid
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        if (this.$refs.messagedialog) {
          this.$nextTick(() => {
            // 请求成功之后，在这里执行
            this.$refs.messagedialog.send(this.chuanid, corpid, this.bigradio)
          })
        }
        if (this.$refs.messagedialogr) {
          this.$nextTick(() => {
            // 请求成功之后，在这里执行
            this.$refs.messagedialogr.send(this.chuanid, corpid, this.bigradio)
          })
        }
      }, 100)
    },
    updatawr() {
      this.messagedialogVisible = false
    },
    huan() {
      // const str1 = `点击下方蓝字，关注公众号即可继续阅读~\n\n╔─👇─👇─👇─╗\n\n✅#公众号:${this.officialAccount}\n\n╚─👆─👆─👆─╝`
      // const str2 = '点击下方蓝字，关注公众号即可继续阅读~\n\n╔─👇─👇─👇─╗\n\n📱📱<a href="此处填写名片链接">点击这里>>继续阅读精彩内容</a>\n\n╚─👆─👆─👆─╝'
      // console.log('this.welcomeWords', this.welcomeWords)
      // // eslint-disable-next-line eqeqeq
      // if (this.welcomeWords == str1) {
      //   console.log('111')
      //   this.welcomeWords = str2
      //   return
      // }
      // // eslint-disable-next-line eqeqeq
      // if (this.welcomeWords == str2) {
      //   console.log('222')
      //   this.welcomeWords = str1
      //   return
      // }
      // // eslint-disable-next-line eqeqeq
      // if (this.welcomeWords != str1 || this.welcomeWords != str2) {
      //   console.log('333')
      //   this.welcomeWords = str1
      //   return
      // }
      // // const str = this.welcomeWords
      // // this.welcomeWords = `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${str}">${str}</a>`

      // dianum1: '',
      // dianum2: ''

      if (this.diantype === 1) {
        this.dianum1 = this.welcomeWords
        this.welcomeWords = this.dianum2

        this.diantype = 2
      } else {
        console.log('this.dianum1', this.dianum1)
        this.dianum2 = this.welcomeWords
        this.welcomeWords = this.dianum1

        this.diantype = 1
      }
      // console.log('this.welcomeWords', this.welcomeWords)
    },
    creatclick(val) {
      console.log('val', val)

      // eslint-disable-next-line eqeqeq
      if (val == 2) {
        this.addnum = 0
      } else {
        this.addnum = 5
      }
    },
    async newlyadded() {
      console.log('新增', this.ids)
      const data = await updayaservicedelter({
        pid: this.ids
      })
      console.log('data', data.data.slave_kf)
      this.slaveKf.push(data.data.slave_kf)
      this.$message({
        message: '新增成功',
        type: 'success'
      })
      this.getlist()
    },
    bigtype(val) {
      console.log('val', val)
      if (val === 1) {
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.messagedialog.send(this.chuanid, this.corpid, this.bigradio)
        }, 100)
      }
      if (val === 2) {
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.messagedialogr.send(this.chuanid, this.corpid, this.bigradio)
        }, 100)
      }
    },
    lookkan(id, type) {
      // type 1 客服访问次数   2 欢迎语发送次数 3 关键词发送次数
      console.log(id, type)
      if (type === 'click') {
        this.lookecharts = true

        this.$nextTick(() => {
          // 请求成功之后，在这里执行
          this.$refs.lookecahrt.send(id, type)
        })

        console.log('客服访问次数')
      } else if (type === 'welcome_send') {
        this.lookecharts = true

        this.$nextTick(() => {
          // 请求成功之后，在这里执行
          this.$refs.lookecahrt.send(id, type)
        })

        console.log('欢迎语发送次数')
      } else if (type === 'keyword_send') {
        this.lookecharts = true

        this.$nextTick(() => {
          // 请求成功之后，在这里执行
          this.$refs.lookecahrt.send(id, type)
        })

        console.log('关键词发送次数')
      } else {
        this.lookecharts = true
        this.$nextTick(() => {
          // 请求成功之后，在这里执行
          this.$refs.lookecahrt.send(id, type)
        })
      }
    },
    onwe(start, newStr) {
      return this.slice(0, start) + newStr + this.slice(start)
    },
    aowrwr(val) {
      // console.log('val', val)
      // this.officialAccount = val
      // eslint-disable-next-line eqeqeq
      // if (this.welcomeWords != '点击下方蓝字，关注公众号即可继续阅读~\n\n╔─👇─👇─👇─╗\n\n📱📱<a href="此处填写名片链接">点击这里>>继续阅读精彩内容</a>\n\n╚─👆─👆─👆─╝') {
      //   this.welcomeWords = `点击下方蓝字，关注公众号即可继续阅读~\n\n╔─👇─👇─👇─╗\n\n✅#公众号:${this.officialAccount}\n\n╚─👆─👆─👆─╝`
      // }

      // var pattern = /#公众号:/
      // // var str = ''
      // // const index = this.welcomeWords.indexOf('#公众号:')
      // // console.log('index', index + 4)
      // // this.welcomeWords.splice(index + 4, this.officialAccount)
      // const str = '123'
      // str.splice(1, '555')
      // console.log('str', str)
      // console.log(pattern.test(this.welcomeWords))

      // var reg = /✅#公众号:/
      var regs = /(?<=#)(.*):(.*)/
      // this.welcomeWords = this.weicawe.replace(reg, '✅#公众号:' + val)
      // this.welcomeWords = this.welcomeWords.replace(regs, '公众号:' + val)
      // 解决复制三个
      this.welcomeWords = '╔─👇─👇─👇─╗\n\n✅#公众号:\n\n╚─👆─👆─👆─╝'
      this.welcomeWords = this.welcomeWords.replace(regs, '公众号:' + val + '\n\n✅#公众号:' + val + '\n\n✅#公众号:' + val)
      // this.welcomeWords = ''
      // this.welcomeWords = data.replace(reg, '#公众号:' + val)
      // const insertStr = (soure, start, newStr) => {
      //   return soure.slice(0, start) + newStr + soure.slice(start)
      // }
      // const index = this.welcomeWords.indexOf('#公众号:')
      // const data = insertStr(this.welcomeWords, index + 5, val)
      // this.welcomeWords = ''
      // this.welcomeWords = data
    },
    // 养号变化
    yangnumber(val) {
      console.log('val', val)
      if (this.qiyedisabled === false) {
        // eslint-disable-next-line eqeqeq
        if (val == 1) {
          this.corpKeyId = null
          this.yuanids = []
          this.selectoptionsyuan = []
        }
      }
    },
    serviceprovider() {
      this.serviceproviderview = true
    },
    wechatclirclr() {
      this.wechatdrawerr = true
      this.$nextTick(() => {
        this.$refs.wechatsetview.udaer()
      })
    },
    copycustomer(kf_open_id) {
      this.$confirm('是否需要复制此客服, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          copyStoreV3({
            id: kf_open_id
          }).then(res => {
            this.getlist()
            this.$message({
              type: 'success',
              message: '复制成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消复制'
          })
        })
    },
    async getconfig() {
      const res = await getQcConfig()
      this.config = res.data
    },
    async httpRequest(e) {
      console.log('e:', e)
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const arr = []
      console.log(arr)
      const img = new Image()
      // const videoWidth = 0
      // const videoHeight = 0
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        // const temporary = e.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // temporary !== '多张' && (img.src = temporary)
        // this.temporary = temporary
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options.Key)
            // this.updataimg = this.config.domain + res.files[0].options.Key
            // this.cover = res.files[0].options.Key
            //     console.log('上传图片data', data)
            // eslint-disable-next-line eqeqeq
            if (this.pictype == true) {
              this.avatarlist.splice(this.avatarlist.length - 1, 1)
            }
            this.avatarlist.push(res.files[0].options.Key)
            this.avatarindex = this.avatarlist.length - 1
            this.testsrc = res.files[0].options.Key
            this.pictype = true
            console.log(' this.avatarlist', this.avatarlist)
            this.caidialogVisible = false
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.emer_box {
  padding: 20px;
}
::v-deep .el-switch__core {
  width: 70px !important;
}
.sers {
  display: flex;
  align-items: center;
}
.addserbox {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.link_box {
  max-height: 300px;
  overflow: auto;
}
/deep/ .el-drawer.rtl {
  width: 60% !important;
}
.link_box::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.link_box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #cfcbcb;
}
.link_box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}
.sewawa {
  display: flex;
  align-items: center;
}
.chooseimg {
  width: 80px;
  height: 80px;
}
.chooseimgwe {
  width: 40px;
  height: 40px;
}
.chooseimgr {
  width: 50px;
  height: 50px;
}
.welcometext {
  width: 93px;
  text-align: right;
}
.titip {
  width: 132px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
}
// .upload-demo /deep/ .el-upload-dragger{
//       width: auto;
//       height: auto;
//       border: none;
// }
// .choosecover{
//   display: flex;
//   align-items: center;
// }
// .choose_cover{
//   margin-left: 10px;
//   margin-right: 10px;
// }
// .cropper-content .cropper {
//         width: auto;
//         height: 300px;
// }

.task_box {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.updata_box {
  width: 708px;
  border: 1px solid #dddee1;
  padding: 10px;
  margin-bottom: 10px;
}
.pic_img {
  width: 100px;
  height: 100px;
  padding: 10px;
}
.pic_box {
  width: 238px;
  border: 1px solid #ccc;
  position: relative;
}
.writtenwords {
  /* padding: 20px; */
  white-space: pre-line;
}
.imaetext {
  display: flex;
  justify-content: space-between;
}
.imagetext {
  padding: 10px;
}
.image_title {
  margin-bottom: 20px;
}
.tab_box {
  width: 708px;
  border: 1px solid #dddee1;
  padding: 5px 24px 52px 15px;
  margin-top: 20px;
}
.add_boxr {
  width: 708px;
  border: 1px dashed #999999;
  padding: 5px 0px;
  text-align: center;
  margin-top: 15px;
}
.examples_leftbox {
  width: 258px;
  height: 112px;
  border: 1px solid #dddee1;
  padding: 5px 10px;
}
.within_box {
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
}
.se_top {
  margin-top: 14px;
}
.describe_text {
  color: #999999;
}
.input_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.allexamples_box {
  display: flex;
  margin-top: 20px;
}
.examples_rightbox {
  margin-left: 30px;
}
.cover_box {
  display: flex;
}
.choose_cover {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 4px;
  color: #1890ff;
  font-weight: 500;
}
.cropper-content .cropper {
  width: auto;
  height: 300px;
}
.upload-demo /deep/ .el-upload-dragger {
  width: auto;
  height: auto;
  border: none;
}
.uopatatextimg {
  width: 100px;
  height: 100px;
  margin-top: 20px;
  object-fit: contain;
}
.choosecover {
  display: flex;
  align-items: center;
}
.text_wei {
  flex-shrink: 0;
}
.chooseitem {
  margin-bottom: 30px;
}
.save_box {
  margin-top: 10px;
}
.choose_textr {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.link_url {
  margin: 0 10px;
}
.btn_determine {
  margin-top: 30px;
  text-align: right;
}
.tips_mask {
  position: absolute;
  top: 0;
  opacity: 0.5;
  background: #000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 55px;
  justify-content: space-around;
}
.tipicon {
  font-size: 25px;
  color: white;
}
.add_name {
  /* margin: 10px 0px 0px 0px; */
  margin-right: 10px;
}
.phone_box {
  background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
  background-size: 100% 100%;
  width: 300px;
  height: 600px;
  margin-left: 100px;
  position: relative;
}
.phone_content {
  width: 224px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
  padding: 10px 25px 14px 11px;
  box-sizing: border-box;
}
.phone_contentone {
  width: 224px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
}
.phone_data {
  color: #d1dfff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.phone_item {
  margin-bottom: 10px;
}
.add_template {
  display: flex;
}
.choose_plate {
  display: flex;
  align-items: center;
}
.aerw {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap:10px;
}
.sedab {
  display: flex;
  align-items: center;
}
.sedabone {
  display: flex;
  align-items: center;
  margin: 20px 0px;
}
.sadewname {
  margin: 0 20px;
}
.idpada_box {
  max-height: 200px;
  overflow: scroll;
  overflow-x: hidden;
}
.idpada_box::-webkit-scrollbar {
  width: 10px;
  background-color: #fff;
}
.idpada_box:hover ::-webkit-scrollbar-track-piece {
  /*鼠标移动上去再显示滚动条*/
  background-color: #fff;
  /* 滚动条的背景颜色 */
  border-radius: 6px;
  /* 滚动条的圆角宽度 */
}

.idpada_box:hover::-webkit-scrollbar-thumb:hover {
  background-color: #c0cecc;
}
.idpada_box:hover::-webkit-scrollbar-thumb:vertical {
  background-color: #ccc;
  border-radius: 6px;
  outline: 2px solid #fff;
  outline-offset: -2px;
  border: 2px solid #fff;
}
.wedarfs {
  width: 70px;
  text-align: right;
}
/deep/ .el-textarea__inner {
  min-height: 160px !important;
}
.daswrwq {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.popup-mid{
  width:100vw;
}
.btn-wrap-box{
  display:flex;
}
</style>
